import { ActorsApi, Configuration as ActorsConfig } from 'api/actor';
import { ClientsApi, Configuration as ClientsConfig } from 'api/clients';
import { ConnexionsApi, CourtiersApi, Configuration as CourtiersConfig } from 'api/courtiers';
import { ReferentialsApi, Configuration as ReferentialsConfig } from 'api/referential';
import { CopropertiesApi, Configuration as CopropertiesConfig } from 'api/coproperty';
import { DocumentsApi, Configuration as DocumentsConfig } from 'api/documents';
import { createApiConfig } from './adapters';
import { ContractsApi, Configuration as ContractsConfig } from 'api/contract';
import { BorrowersApi, Configuration as BorrowersConfig } from 'api/borrower';
import { Configuration as PricingConfig, PricingApi } from 'api/pricing';
import { Configuration as QuotesConfig, QuotesApi } from 'api/quote';
import { Configuration as TenantsConfig, TenantsApi } from 'api/tenant';
import { Configuration as FilesConfig, FilesApi } from 'api/files';
import { Configuration as ShoppingCartConfig, ShoppingCartApi } from 'api/shopping-cart';
import { Configuration as BrokersConfig, BrokersApi } from 'api/broker';
import { Configuration as PlateformesConfig, PlateformesApi } from 'api/plateforme';
import { Configuration as ProductsConfig, ProductsApi } from 'api/product';
import { Configuration as GuaranteesConfig, GuaranteesApi } from 'api/guarantee';
import { Configuration as IndicesConfig, IndicesApi, BranchesApi } from 'api/indice';
import {
  Configuration as FunnelsConfig,
  FunnelsApi,
  ReferentialsApi as FunnelReferentialsApi,
  ActorsApi as FunnelActorsApi,
  ExpressionsApi as FunnelExpressionsApi,
} from 'api/funnel';
import { Configuration as AccountsConfig, AccountsApi } from 'api/account';
import { Configuration as BankAccountsConfig, BankAccountsApi } from 'api/bank-account';
import { Configuration as EmailsConfig, EmailsApi } from 'api/email';
import { Configuration as StatisticsConfig, StatisticsApi } from 'api/statistic';
import { Configuration as NotesConfig, NotesApi } from 'api/note';
import { Configuration as LeadsConfig, LeadsApi } from 'api/lead';
import { Configuration as ValidationsConfig, ValidationsApi } from 'api/validation';
import { Configuration as RolesConfig, RolesApi } from 'api/role';
import { Configuration as AtelierRolesConfig, AtelierRolesApi } from 'api/atelier-roles';
import { Configuration as AttributionsPlateformesConfig, AttributionsPlateformesApi } from 'api/attributions-plateformes';
import { Configuration as SearchConfig, SearchApi } from 'api/search';
import { Configuration as SurveyConfig, SurveyApi } from 'api/survey';
import {
  Configuration as ActivityFeedConfig,
  ActivityFeedApi,
} from 'api/activity-feed';
import {
  Configuration as PaymentScheduleConfig,
  PaymentScheduleApi,
} from 'api/payment-schedule';

export const actorsAPI = new ActorsApi(createApiConfig(ActorsConfig));
export const clientsAPI = new ClientsApi(createApiConfig(ClientsConfig));
export const courtiersAPI = new CourtiersApi(createApiConfig(CourtiersConfig));
/** Journal des connexions (liste admin BO), porté par le paquet courtiers. */
export const connexionsAPI = new ConnexionsApi(createApiConfig(CourtiersConfig));
export const documentsAPI = new DocumentsApi(createApiConfig(DocumentsConfig));
export const contractsAPI = new ContractsApi(createApiConfig(ContractsConfig));
export const referentialsApi = new ReferentialsApi(createApiConfig(ReferentialsConfig));
export const copropertiesApi = new CopropertiesApi(createApiConfig(CopropertiesConfig));
export const statisticsAPI = new StatisticsApi(createApiConfig(StatisticsConfig));
export const borrowersAPI = new BorrowersApi(createApiConfig(BorrowersConfig));
export const pricingAPI = new PricingApi(createApiConfig(PricingConfig));
export const quotesAPI = new QuotesApi(createApiConfig(QuotesConfig));
export const tenantsAPI = new TenantsApi(createApiConfig(TenantsConfig));
export const filesAPI = new FilesApi(createApiConfig(FilesConfig));
export const shoppingCartAPI = new ShoppingCartApi(createApiConfig(ShoppingCartConfig));
export const brokersAPI = new BrokersApi(createApiConfig(BrokersConfig));
export const plateformesAPI = new PlateformesApi(createApiConfig(PlateformesConfig));
export const productsAPI = new ProductsApi(createApiConfig(ProductsConfig));
/** Référentiel des garanties, rattachées aux branches (écran Catalogue > Branches). */
export const guaranteesAPI = new GuaranteesApi(createApiConfig(GuaranteesConfig));
/** Référentiel des indices de branche et de leurs valeurs datées. */
export const indicesAPI = new IndicesApi(createApiConfig(IndicesConfig));
/**
 * Toutes les branches du référentiel, sans restriction liée aux tunnels.
 *
 * À ne pas confondre avec risques/branches-courtier, qui ne remonte que les branches
 * des tunnels simulables par le courtier connecté : juste pour la souscription,
 * incomplet pour un écran d'administration.
 */
export const branchesAPI = new BranchesApi(createApiConfig(IndicesConfig));
export const funnelsAPI = new FunnelsApi(createApiConfig(FunnelsConfig));
/** Référentiels consommés uniquement par la gestion de tunnel (natures de rémunération, types de support). */
export const funnelReferentialsAPI = new FunnelReferentialsApi(createApiConfig(FunnelsConfig));
/** Listes d'acteurs alimentant les sélecteurs d'assureur et de bénéficiaire d'un tunnel. */
export const funnelActorsAPI = new FunnelActorsApi(createApiConfig(FunnelsConfig));
/** Valeurs de variables d'un tunnel (formules de tarification). */
export const funnelExpressionsAPI = new FunnelExpressionsApi(createApiConfig(FunnelsConfig));
export const accountsAPI = new AccountsApi(createApiConfig(AccountsConfig));
export const bankAccountsAPI = new BankAccountsApi(createApiConfig(BankAccountsConfig));
export const emailsAPI = new EmailsApi(createApiConfig(EmailsConfig));
export const notesAPI = new NotesApi(createApiConfig(NotesConfig));
export const leadsAPI = new LeadsApi(createApiConfig(LeadsConfig));
export const validationsAPI = new ValidationsApi(createApiConfig(ValidationsConfig));
export const roleAPI = new RolesApi(createApiConfig(RolesConfig));
export const atelierRolesAPI = new AtelierRolesApi(createApiConfig(AtelierRolesConfig));
export const attributionsPlateformesAPI = new AttributionsPlateformesApi(createApiConfig(AttributionsPlateformesConfig));
export const searchAPI = new SearchApi(createApiConfig(SearchConfig));
export const surveyAPI = new SurveyApi(createApiConfig(SurveyConfig));
export const activityFeedAPI = new ActivityFeedApi(createApiConfig(ActivityFeedConfig));
export const paymentScheduleAPI = new PaymentScheduleApi(createApiConfig(PaymentScheduleConfig));
